export default {
  // View tabs
  signal: 'Signal',
  noise: 'Noise',
  all: 'All',
  owned: 'Owned',
  running: 'Running',
  shared: 'Shared',
  routines: 'Routines',
  skills: 'Skills',
  sent: 'Sent',
  calendar: 'Calendar',
  drafts: 'Drafts',
  attachments: 'Attachments',
  folders: 'Folders',
  myTasks: 'My tasks',
  allTasks: 'All tasks',
  createdByMe: 'Created by me',
  projects: 'Projects',
  myProjects: 'My projects',
  allProjects: 'All projects',
  taskViews: 'Task views',
  projectViews: 'Project views',
  projectsCreatedByMe: 'Projects created by me',
  newProject: 'New project',
  recent: 'Recent',
  people: 'People',
  teams: 'Teams',
  missed: 'Missed',
  unattended: 'Unattended',
  calls: 'Calls',
  missedCalls: 'Missed calls',
  unattendedCalls: 'Unattended calls',

  // Sort options
  sort: 'Sort',
  sortLastViewed: 'Last viewed',
  sortLastUpdated: 'Last updated',
  sortDateCreated: 'Date created',

  // Group options
  groupNone: 'None',
  date: 'Date',
  type: 'Type',
  types: 'Types',
  project: 'Project',
  status: 'Status',
  statuses: 'Statuses',
  priority: 'Priority',
  priorities: 'Priorities',
  assignee: 'Assignee',

  // List controls
  layout: 'Layout',
  layoutList: 'List',
  layoutBoard: 'Board',
  layoutGantt: 'Gantt',
  sortList: 'Sort list',
  groupList: 'Group list',
  filterList: 'Filter list',
  clearFilters: 'Clear filters',

  // Filter menu
  filter: 'Filter',
  filters: 'Filters',
  openFilterMenu: 'Open filter menu',
  docs: 'Docs',
  agents: 'Agents',
  tasks: 'Tasks',
  mail: 'Mail',
  files: 'Files',
  githubPrs: 'GitHub PRs',
  unread: 'Unread',
  read: 'Read',
  notDone: 'Not Done',
  done: 'Done',
  pdfs: 'PDFs',
  images: 'Images',
  documents: 'Documents',
  hasCalendarInvite: 'Has Calendar Invite',
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  inReview: 'In Review',
  completed: 'Completed',
  canceled: 'Canceled',
  urgent: 'Urgent',
  highPriority: 'High Priority',
  mediumPriority: 'Medium Priority',
  lowPriority: 'Low Priority',
  noPriority: 'No Priority',
  canvas: 'Canvas',
  spreadsheet: 'Spreadsheet',
  code: 'Code',
  videos: 'Videos',
  snippets: 'Snippets',
  other: 'Other',
  contactMe: '{{name}} (me)',
  me: 'Me',
  unassigned: 'Unassigned',
  tags: 'Tags',
  filterByTag: 'Filter by tag...',
  searchAssignees: 'Search assignees...',
  searchAssigneesLabel: 'Search assignees',
  createdBy: 'Created by',
  searchCreators: 'Search creators...',
  searchCreatorsLabel: 'Search creators',
  noResults: 'No results',
  searchCategory: 'Search {{category}}...',

  // Inbox selector
  allInboxes: 'All inboxes',
  noInboxes: 'No inboxes',
  oneInbox: '1 inbox',
  inboxCount: {
    one: '{{count}} inbox',
    other: '{{count}} inboxes',
  },
  inboxes: 'Inboxes',
  searchInboxes: 'Search inboxes...',
  connectAnotherAccount: 'Connect another account',
  showAllInboxes: 'Show all inboxes',
  showOnlyInbox: 'Show only {{label}}',
  only: 'Only',
  startedFrom: 'Started from {{origin}}',
  personal: 'Personal',
  savedViews: 'Saved views',
  newSavedView: 'New saved view',
  savedViewsEmptyTitle: 'Your go-to views',
  savedViewsEmptyDescription: 'Save your setup for next time.',
  createSavedView: 'Create view',
  savedTaskViews: 'Saved task views',
  newViewDraft: 'New view, draft',
  newView: 'New view',
  draft: 'Draft',
  sharedWithTeam: '{{name}}, shared with team',
  viewActions: 'Actions for {{name}}',
};
